import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import SearchIcon from "sweet-web/components/icons/SearchIcon";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { Search, searchFocus } from "sweet-web/redux/search/actions";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  flex: 1;
  position: relative;
  box-sizing: border-box;
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 13px 20px 7px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
`;

const SearchInput = styled.input<{ rounded: boolean }>`
  -webkit-appearance: none;
  width: 100%;
  border: 1px solid ${colors.lightGray};
  font-size: 17px;
  color: ${colors.primary};
  outline: none;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  padding: 8px 20px 8px 50px;
  box-sizing: border-box;
  font-weight: 600;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: ${props => (props.rounded ? 0 : 5)}px;
  border-bottom-right-radius: ${props => (props.rounded ? 0 : 5)}px;
  &:hover,
  &:focus {
    color: ${colors.primary};
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
    &::placeholder {
      color: ${colors.primary};
    }
  }
  &::placeholder {
    color: ${colors.gray};
  }
`;

type Props = ConnectedProps<typeof connector>;

const Query: React.FC<Props> = props => {
  const { query, searchFocus, Search, focused, hasResults } = props;
  const [hover, setHover] = useState(false);
  const [value, setValue] = useState(query);

  const debouncedSearch = _.debounce(Search, 200);

  const onChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <Wrapper
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => {
        searchFocus(true);
        debouncedSearch(value ? value : " ");
      }}
      onBlur={() => {
        searchFocus(false);
      }}
    >
      <SearchInput
        placeholder="Make events happen"
        type="text"
        value={value}
        onChange={onChange}
        rounded={hasResults && focused}
      />
      <SearchIconWrapper>
        <SearchIcon
          color={
            focused || hover || Boolean(value) ? colors.primary : colors.gray
          }
          style={{ marginBottom: 2 }}
        />
      </SearchIconWrapper>
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  query: selectors.searchQuery(state),
  hasResults: selectors.searchHasResults(state),
  focused: selectors.searchFocused(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      Search,
      searchFocus
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Query);
